export const API_URL = process.env.REACT_APP_API_URL;
export const defaultValueofSkeltonLoader = 3;
export const test = '';
